﻿import { ajaxGet, ajaxPost } from '../../utils/ajax';

export default {
    getOrder(orderGuid, callback, errorCallback) {          
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/GetOrderByGUIDAsync?orderGUID=" + orderGuid;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },   
    cancelOrder(orderId, dealerCode, channelType, callback, errorCallback){
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/CancelOrderAsync?orderID=" + orderId + "&dealerCode=" + dealerCode + "&channelType=" + channelType;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    updateOrder(orderId, context, answer, errorCallback){
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/UpdateOrder?orderID=" + orderId + "&context=" + context + "&answer="+ answer;
        ajaxGet(url, true, true)
         .catch(errorCallback);
    },

    getPreAuth(orderId, clientId, currencyIsoString, dealerCode, amount, vatAmount, paymentTerms, authenticationType, authenticationRef, cashierRef, callback, errorCallback) {   
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/PreAuth?orderId=" + orderId + "&clientId=" + clientId + "&currencyIsoString=" +currencyIsoString + "&dealerCode=" + dealerCode + "&amount=" + amount + "&vatAmount=" + vatAmount +"&paymentTerms=" + paymentTerms + "&authenticationType=" + authenticationType +"&authenticationRef=" + authenticationRef + "&cashierRef=" + cashierRef;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);        
    },
    getJoiceCreditCheck(orderId, amount, vatAmount, callback, errorCallback) {
        const url = "/teliadk/CustomerOrderInfoCreditAccountBlock/JoiceCreditCheck?orderId=" + orderId + "&amount=" + amount + "&vatAmount=" + vatAmount;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    getDownPaymentPlan(orderId, callback, errorCallback) {     
        var url = "/teliadk/OrderItemsCreditAccountBlock/GetDownPaymentPlanAsync?orderId=" + orderId;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    submitOrder(orderId, params, callback, errorCallback){
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/SubmitOrder?orderID=" + orderId;
        ajaxPost(url, params)
            .then(callback)
            .catch(errorCallback);
    },
    submitOrderForRemoteChannel(orderId, params, callback, errorCallback){
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/SubmitOrderForRemoteChannel?orderID=" + orderId;
        ajaxPost(url, params)
            .then(callback)
            .catch(errorCallback);
    },
    getPricePlanName(subscriptionId, offeringCode, callback){
        var url = "/teliadk/OrderSummaryCreditAccountBlock/GetPricePlan?subscriptionId=" + subscriptionId + "&offeringCode=" + offeringCode;
        ajaxGet(url, true, false)
            .then(callback);
    },
    getAdditionalProductName(subscriptionId, offeringCode, callback){
        var url = "/teliadk/OrderSummaryCreditAccountBlock/GetAdditionalProduct?subscriptionId=" + subscriptionId + "&offeringCode=" + offeringCode;  
        ajaxGet(url, true, false)
            .then(callback);
    },
    getDirectoryListingText(subscriptionId, directoryListingCode, callback){
        var url = "/teliadk/OrderSummaryCreditAccountBlock/GetDiretcoryListingCode?subscriptionId=" + subscriptionId + "&directoryListingCode=" + directoryListingCode;   
        ajaxGet(url, true, false)
            .then(callback);   
    },   
    getConsentData(subscriptionId, referenceTypeId, language, consentId, callback) {
        var url = "/teliadk/OrderSummaryCreditAccountBlock/GetConsentData?subscriptionId=" + subscriptionId + "&referenceTypeId=" + referenceTypeId + "&language=" + language + "&consentId=" + consentId;
        ajaxGet(url, true, false)
            .then(callback);
    },
    getLegalOwnerEmailFromCDS(orderId, dealerCode, channelType, userId, ban, callback){         
        var url = "/teliadk/OrderSummaryCreditAccountBlock/GetLegalOwnerEmailFromCDS?orderId=" + orderId + "&dealerCode=" + dealerCode + "&channelType=" + channelType + "&userId=" + userId + "&ban=" + ban;
        ajaxGet(url, true, false)
            .then(callback);   
    },
    logPBSInfo(orderId, field, value){
        var url = "/teliadk/PBSInformationCreditAccountBlock/LogPBSInfo?orderId=" + orderId + "&field=" + field + "&value=" + value;
        ajaxGet(url, false, true);
    }
}